import { Box } from "@material-ui/core";
import React from "react";
import {
    useGetRolesQuery,
    useGetUserListQuery,
    useUpdateUserMutation,
} from "../../generated/graphql";
import DefaultQueryHandler from "../../common/DefaultQueryHandler";
import { PasteToClipboard } from "../../common/Util";
import NotificationPopup from "../../common/NotificationPopup";
import { DataGridLocale } from "../../common/DataGridLocale";
import {
    GridColDef,
    GridToolbarContainer,
    GridToolbarExport,
    GridValueGetterParams,
    DataGridPro, GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import UpdateUser from "./UpdateUser";
import StatusSwitch from "../../components/StatusSwitch";
import {useUser} from "../../Auth";

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport csvOptions={{utf8WithBom:true}}/>
        </GridToolbarContainer>
    );
}
export default () => {
    const currentUser = useUser();
    const { loading, data, error } = useGetUserListQuery({
        variables: { includeDisabled: true },
    });
    const [updateUser] = useUpdateUserMutation();
    const rolesQuery = useGetRolesQuery();
    const columns: GridColDef[] = [
        { field: "name", headerName: "姓名", width: 150 },
        { field: "email", headerName: "Email", width: 300 },
        {
            field: "roles",
            headerName: "角色",
            width: 400,
            valueGetter: (params: GridValueGetterParams) => {
                return (params?.row.roles as Array<any>)
                    .map(({ name }) => name)
                    .join(", ");
            },
        },
        {
            field: "disabled",
            headerName: "狀態",
            width: 140,
            valueGetter: (params: GridValueGetterParams) =>
                params.row.disabled ? "停用" : "啟用",
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <StatusSwitch
                        key={params.row.id}
                        enabled={!params.row.disabled}
                        disabled={currentUser?.id == null || String(params.row.id) === String(currentUser.id)}
                        onChange={async (enabled) => {
                            try {
                                await updateUser({
                                    variables: {
                                        id: params.row.id,
                                        user: {
                                            disabled: !enabled,
                                        },
                                    },
                                    refetchQueries: ["getUserList"],
                                });
                                NotificationPopup.success(`已${enabled ? "啟用" : "停用"}`);
                            } catch (e) {
                                NotificationPopup.error(`修改狀態發生問題: ${e.message}`);
                                throw e;
                            }
                        }}
                    />
                );
            },
        },
        {
            field: "test",
            headerName: "動作",
            width: 200,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <UpdateUser user={params.row}/>
                );
            },
        },
    ];
    return (
        <DefaultQueryHandler
            error={error}
            loading={!data && (loading || rolesQuery.loading)}
        >
            <Box width={"100%"} style={{ marginTop: "30px", height: "100vh" }}>
                <DataGridPro
                    pagination
                    pageSize={10}
                    columns={columns}
                    rows={data?.users!}
                    autoHeight={true}
                    localeText={DataGridLocale}
                    onCellClick={PasteToClipboard}
                    initialState={{
                        filter: {
                            filterModel: {
                                items: [
                                    {
                                        id: 1,
                                        columnField: "disabled",
                                        operatorValue: "equals",
                                        value: "啟用",
                                    },
                                ],
                            },
                        },
                    }}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    sx={{
                        "& [data-field='disabled'] .MuiDataGrid-iconButtonContainer": {
                            visibility: "visible",
                            width: "auto",
                        },
                    }}
                />
            </Box>
        </DefaultQueryHandler>
    );
};
